"use strict";
// This file is generated by devtools.
// Do not edit this file directly.
Object.defineProperty(exports, "__esModule", { value: true });
exports.validator = exports.steatosisGradeMessages = exports.fibrosisStageMessages = exports.SteatosisGrade = exports.FibrosisStage = void 0;
const schema_1 = require("../../../../schema");
var FibrosisStage;
(function (FibrosisStage) {
    FibrosisStage["F0"] = "F0";
    FibrosisStage["F1"] = "F1";
    FibrosisStage["F2"] = "F2";
    FibrosisStage["F3"] = "F3";
    FibrosisStage["F4"] = "F4";
})(FibrosisStage || (exports.FibrosisStage = FibrosisStage = {}));
var SteatosisGrade;
(function (SteatosisGrade) {
    SteatosisGrade["S0"] = "S0";
    SteatosisGrade["S1"] = "S1";
    SteatosisGrade["S2"] = "S2";
    SteatosisGrade["S3"] = "S3";
})(SteatosisGrade || (exports.SteatosisGrade = SteatosisGrade = {}));
exports.fibrosisStageMessages = {
    [FibrosisStage.F0]: {
        id: "ltx.phaseI.consultations.liverElastography.fibrosisStage.F0",
        defaultMessage: "F0"
    },
    [FibrosisStage.F1]: {
        id: "ltx.phaseI.consultations.liverElastography.fibrosisStage.F1",
        defaultMessage: "F1"
    },
    [FibrosisStage.F2]: {
        id: "ltx.phaseI.consultations.liverElastography.fibrosisStage.F2",
        defaultMessage: "F2"
    },
    [FibrosisStage.F3]: {
        id: "ltx.phaseI.consultations.liverElastography.fibrosisStage.F3",
        defaultMessage: "F3"
    },
    [FibrosisStage.F4]: {
        id: "ltx.phaseI.consultations.liverElastography.fibrosisStage.F4",
        defaultMessage: "F4"
    }
};
exports.steatosisGradeMessages = {
    [SteatosisGrade.S0]: {
        id: "ltx.phaseI.consultations.liverElastography.steatosisGrade.S0",
        defaultMessage: "S0"
    },
    [SteatosisGrade.S1]: {
        id: "ltx.phaseI.consultations.liverElastography.steatosisGrade.S1",
        defaultMessage: "S1"
    },
    [SteatosisGrade.S2]: {
        id: "ltx.phaseI.consultations.liverElastography.steatosisGrade.S2",
        defaultMessage: "S2"
    },
    [SteatosisGrade.S3]: {
        id: "ltx.phaseI.consultations.liverElastography.steatosisGrade.S3",
        defaultMessage: "S3"
    }
};
const fibrosisStage = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(FibrosisStage.F0),
    schema_1.Schema.singleChoiceItem(FibrosisStage.F1),
    schema_1.Schema.singleChoiceItem(FibrosisStage.F2),
    schema_1.Schema.singleChoiceItem(FibrosisStage.F3),
    schema_1.Schema.singleChoiceItem(FibrosisStage.F4)
])
    .expiration(15552000)
    .interpretation({ vocab: "ltx", code: "fibrosis_stage" });
const steatosisGrade = schema_1.Schema.singleChoice([
    schema_1.Schema.singleChoiceItem(SteatosisGrade.S0),
    schema_1.Schema.singleChoiceItem(SteatosisGrade.S1),
    schema_1.Schema.singleChoiceItem(SteatosisGrade.S2),
    schema_1.Schema.singleChoiceItem(SteatosisGrade.S3)
])
    .expiration(15552000)
    .interpretation({ vocab: "ltx", code: "steatosis_grade" });
const comment = schema_1.Schema.string()
    .optional()
    .maxLength(10000)
    .interpretation({ vocab: "ltx", code: "liver_elastography_comment" });
exports.validator = schema_1.Schema.object()
    .default({})
    .sealed(true)
    .properties({ fibrosisStage, steatosisGrade, comment })
    .interpretation({ vocab: "ltx", code: "liver_elastography" });
